/*eslint-disable*/
import React from 'react';
import { Container, Row } from 'reactstrap';
// used for making the prop types of this component
import PropTypes from 'prop-types';

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={'footer' + (this.props.default ? ' footer-default' : '') + ' mb-0 mt-0'}
      >
        <div className='framework-flexcontainer mt-0'>
          <div>
            {''}
          </div>
          <div className='text-right framework-flex-rigth mt-0'>
            <span className='copyright mr-2'>
              Ver 1.1.0 &copy; Orden Express {1900 + new Date().getYear()}
            </span>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;

/*<Container
        fluid={this.props.fluid ? true : false}
        name='mt-0 mb-0'>
          <Row>
            <nav className='footer-nav'>
              <ul>
                <li>
                  <a href='https://www.creative-tim.com'>Creative Tim</a>
                </li>
                <li>
                  <a href='https://blog.creative-tim.com'>Blog</a>
                </li>
                <li>
                  <a
                    href='https://www.creative-tim.com/license'
                    target='_blank'
                  >
                    Licenses
                  </a>
                </li>
              </ul>
            </nav>
            <div className='credits ml-auto text-right'>
              <span className='copyright'>
                &copy; Orden Express {1900 + new Date().getYear()}
                , made with{' '}
                <i className='fa fa-heart heart' /> by Creative Tim}
              </span>
            </div>
          </Row>
        </Container>*/